<template>
  <div v-loading="loading">
    <el-table class="w100 tx-c my-table" :data="list" row-class-name="cu-p" stripe border empty-text="暂无已发布记录" height="600px" @row-click="clickRowItem">
      <el-table-column label="申请内容" align="center" prop="processTitle"></el-table-column>
      <el-table-column align="center" label="发起时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="耗时" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.costTimes | costTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <span class="blue cu-p" v-if="hasUrl == ''" @click.stop="clickRow(scope.row, 'aws')">查看</span>
          <a class="blue cu-p" v-else :href="scope.row.taskUrl" target="_blank">查看</a>
          <!-- <a class="blue cu-p" :href="scope.row.taskUrl" target="_blank">查看</a> -->
          <span class="ml10 orange cu-p" @click.stop="clickRow(scope.row, 'lc')">流程跟踪</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <a class="none" ref="href" :href="hasUrl" target="_blank"></a>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ServerInfoTabYFB",
  props: {
    hasUrl: String
  },
  data() {
    return {
      loading: false,

      error: 0,
      page: 1,
      size: 30,
      total: 0,
      list: []
    };
  },
  computed: {
    ...mapState(["userToken", "userData"])
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;

      this.$http
        .post(
          "task/findLaunchedProcessPage",
          this.$qs.stringify({
            pageNum: this.page,
            pageSize: this.size,
            processDefId: this.$route.query.id
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.RetStatus == 0 && data.RetCode) {
            this.list = data.RetData.list;
            this.total = data.RetData.total;
          } else {
            this.$notify({
              title: "错误",
              message: data.RetMsg,
              type: "error",
              offset: 60
            });
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changeSize(value) {
      this.size = value;
      this.fetchData();
    },
    changePage(value) {
      this.page = value;
      this.fetchData();
    },
    clickRowItem(row) {
      if (this.hasUrl != "") {
        this.$refs.href.click();
      } else {
        this.clickRow(row, "aws");
      }
    },
    clickRow(row, type) {
      if (row.taskUrl && row.taskUrl != "" && type == "aws") {
        this.$emit("show-aws", row.taskUrl);
      } else if (type == "lc" && row.processInstId != "") {
        this.$emit(
          "show-aws",
          `/hall/aws/portal/r/w?sid=${this.userToken}&cmd=CLIENT_BPM_FORM_TRACK_OPEN&processInstId=${row.processInstId}&supportCanvas=true`
        );
      }
    }
  }
};
</script>

<style>
</style>
